import getStringParts from "../../../../utils/get-string-parts";

/**
 * Create a trigger hashed name
 * @param {String} name
 * @param {String} rest
 * @returns {String}
 */
const getTriggerHash = (name, rest = "") => {
  return `${name}_${getStringParts(rest)}`;
}

export default getTriggerHash;